module.exports = __webpack_public_path__ + "static/media/icon-play-fill.56f3065b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/classroom/icon-play-fill.png
// module id = 1885
// module chunks = 6